// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"cbafa981","297":"11b0aa3e","453":"12192ec0","526":"8f6bca14"}[chunkId] + ".chunk.js";
};